import styled, { css } from 'styled-components';

type Props = {
  subtler?: boolean;
};

export const EllipseStyled = styled.div<Props>`
  ${({ subtler }) =>
    subtler
      ? css`
          background-color: var(
            --ds-background-accent-gray-subtler,
            var(--ds-fb-background-accent-gray-subtler)
          );
        `
      : css`
          background-color: var(
            --ds-icon-accent-gray,
            var(--ds-fb-icon-accent-gray)
          );
        `}
  width: 4px;
  height: 4px;
  flex: none;
  border-radius: 50%;
`;
